/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Checkbox, FormControlLabel, TextareaAutosize } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import DropZone from '../../Components/DropZone';
import PageLayout from '../../Components/PageLayout';
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { useNavigate } from 'react-router-dom';



function SelectTypeTransaction(props) {

    const navigation = useNavigate();



    return (
        <PageLayout title='ملک مورد نظر خود را ثبت کنید'>
            <img src='/assets/img/plucHome.png' className='pluc-home-img' />
            <Box className="has-pluc-box" sx={{ px: 3 }}>
                <Typography sx={{ fontSize: '17px', color: '#4A4949' }} component="div">
                    نوع معامله را انتخاب کنید
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px' }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }}
                        onClick={() => {
                            navigation("/submit-property/sale")
                        }} >
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        navigation("/submit-property/rent")
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
            </Box>
        </PageLayout >
    );
}

export default SelectTypeTransaction;